import store from '../../../store'
import { pushFunctionLayer } from '../../../store/functionLayer'
import { APPLICATION_FUNCTION_EXTERNAL_ID } from '..'
import { ProjectEditDialogConfig } from './hooks/projectEditDialogData'

// projectEdit をダイアログ（FunctionLayer）として開く汎用ヘルパ。
// 登録時はDB保存せず config.onComplete に入力値を返す。ProgramManagement 等から利用。
export const openProjectEditDialog = (config: ProjectEditDialogConfig) => {
  store.dispatch(
    pushFunctionLayer({
      // enum はトップレベルではなく実行時（関数内）で参照し循環参照を避ける。
      externalId: APPLICATION_FUNCTION_EXTERNAL_ID.PROJECT_REGISTRATION,
      code: config.initial?.code || undefined,
      hideHeader: true,
      auxiliaries: { projectEditDialog: config },
    })
  )
}
